import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import {
  InfoBoxContainer,
  InfoBoxHeader,
  InfoBoxHeaderWrapper,
  InfoBoxContent,
  InfoBoxTitle,
  InfoBoxExcerpt,
  InfoBoxFooter,
  InfoBoxNavButton,
  InfoBoxPagination,
  InfoBoxClose,
  InfoBoxLink,
} from './MapPin.css';

const InfoBox = ({ country, projects, onClose, style }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const containerRef = useRef(null);

  // Handle ESC key to close
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  if (!projects || projects.length === 0) {
    return null;
  }

  const currentProject = projects[currentIndex];
  const projectData = currentProject?.node?.data;
  const projectUid = currentProject?.node?.uid;

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(projects.length - 1, prev + 1));
  };

  const handleNavigateToProject = () => {
    if (projectUid) {
      navigate(`/${projectUid}`);
      // navigate(`/projects/${projectUid}`);
    }
  };

  const canGoPrev = currentIndex > 0;
  const canGoNext = currentIndex < projects.length - 1;

  return (
    <InfoBoxContainer ref={containerRef} style={style}>
      <InfoBoxHeaderWrapper>
        <InfoBoxClose onClick={onClose} aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </InfoBoxClose>
        <InfoBoxHeader>{country}</InfoBoxHeader>
      </InfoBoxHeaderWrapper>
      <InfoBoxLink onClick={handleNavigateToProject}>
        <InfoBoxContent>
          <InfoBoxTitle>
            {projectData?.title?.text || 'Untitled Project'}
          </InfoBoxTitle>
          <InfoBoxExcerpt>
            {projectData?.excerpt?.text || 
             projectData?.project_sections?.[0]?.project_section_body?.text?.substring(0, 150) + '...' ||
             'No description available.'}
          </InfoBoxExcerpt>
        </InfoBoxContent>
      </InfoBoxLink>
      {projects.length > 1 && (
        <InfoBoxFooter>
          <InfoBoxNavButton
            onClick={handlePrev}
            disabled={!canGoPrev}
            aria-label="Previous project"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </InfoBoxNavButton>
          <InfoBoxPagination>
            {currentIndex + 1}/{projects.length}
          </InfoBoxPagination>
          <InfoBoxNavButton
            onClick={handleNext}
            disabled={!canGoNext}
            aria-label="Next project"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </InfoBoxNavButton>
        </InfoBoxFooter>
      )}
    </InfoBoxContainer>
  );
};

InfoBox.propTypes = {
  country: PropTypes.string.isRequired,
  projects: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  style: PropTypes.object,
};

export default InfoBox;
